import React from 'react';
import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';

import moment from 'moment';
import { Line } from 'react-chartjs-2';
// eslint-disable-next-line no-unused-vars
import { Chart as ChartJS } from 'chart.js/auto'

// eslint-disable-next-line no-unused-vars
import { Chart }            from 'react-chartjs-2'

function HighEffortItem(props){
  function getFormattedDate(time){
    return moment(time,"YYYY-MM-DD").format("DD-MMM")
  }
  const chartoptions={'type': 'bar',indexAxis: 'y'}
  var chartDate =props.item!==0 
  ? {
    labels:props.item.map((record)=>(getFormattedDate(record.startDate))),
    datasets: [
      {
        label: 'Learning Progress',
        type: 'bar',
        
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
        data:props.item.map((record)=>(record.percentage))
        
      }
    ]
  }:null;
  return (
    <>
   {props.item && 
   <> <h3><u>{props.item[0].name}</u></h3>
   <h5>Estimated Completion Date {props.item[0].estimatedCompletionDate}</h5>
    <Line options={chartoptions} data={chartDate}/>
   </>}
   </>
  )
}

function HighEffort(props){

  var itemNames=[]
  var allItems =[] 
  if(props && props.data && props.data.data){
  for(var i=0;i<props.data.data.length;i++){
    if(props.data.data[i].type==="learning" &&  props.data.data[i].highEffortProgress && props.data.data[i].highEffortProgress.items){
      for(var j=0;j<props.data.data[i].highEffortProgress.items.length;j++){
        var name = props.data.data[i].highEffortProgress.items[j].name
        const item ={...props.data.data[i].highEffortProgress.items[j],'startDate':props.data.data[i].startDate}
        allItems.push(item)
        if(itemNames.indexOf(name)<0)
        itemNames.push(name)
      }
    }

  }
}

  return(
    <>
    {itemNames.map(itemName=>{
      const itemP = allItems.filter(item=>item.name===itemName)
      return (
        <HighEffortItem item={itemP}></HighEffortItem>
      )
    })}
    </>
  )
}

function LearningCurveResult(props) {
 
  console.log("Size"+props.data.length)
  function getFormattedDate(time){
    return moment(time,"YYYY-MM-DD").format("DD-MMM")
  }

  
  return (
    <>
    
    {props.data.length!==0 && <><Table striped bordered hover>
      <thead>
        <tr>
          <th>#</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Completed Learning Counter</th>
      
        </tr>
      </thead>
      <tbody>
        {
          
          props.data.map((record, index)=>(
            record.type==="learning" &&  <tr key={index}>
          <td>{index+1}</td>
          <td>{getFormattedDate(record.startDateQueryParam)}</td>
          <td>{getFormattedDate(record.endDateQueryParam)}</td>
          <td class={record.previousResult  && record.completedKnowledgeCounter && record.previousResult.completedKnowledgeCounter && record.previousResult.completedKnowledgeCounter.count>record.completedKnowledgeCounter.count?"text-danger":""} >{record.completedKnowledgeCounter.count}</td>
          
        </tr>
          ))
         
      }
      </tbody>
    </Table>
    <HighEffort data={props} />
    </>
}


{
  props.data.length===0 && <><Form.Control plaintext readOnly defaultValue="Loading Report..." /><Spinner animation="border" role="status">
  <span className="visually-hidden">Loading...</span>
</Spinner> </>
}
    </>
  );

}
export default LearningCurveResult;